import { Routes } from '@angular/router';
import { AuditTrailComponent } from './audit-trail/audit-trail.component';
import { CreateUsersComponent } from './create-users/create-users.component';
import { ManageRolesComponent } from './manage-roles/manage-roles.component';
import { UserManagerComponent } from './user-manager/user-manager.component';
import { ManagePubTypeComponent } from './manage-pub-type/manage-pub-type.component';
import { ManagePlanTypeComponent } from './manage-plan-type/manage-plan-type.component';
import { UserManagementLandingComponent } from './user-management-landing/user-management-landing.component';
import { ImpactAssessmentSettingsComponent } from './impact-assessment-settings/impact-assessment-settings.component';
import { RulebookSettingsComponent } from './rulebook-settings/rulebook-settings.component';
import { ReportingSettingsComponent } from './reporting-settings/reporting-settings.component';
import { ThemeSettingsComponent } from './theme-settings/theme-settings.component';
import { ProjectNameListComponent } from './project-name-list/project-name-list.component';

export const UserManagementRoutes: Routes = [{
    path: '',
    component: UserManagementLandingComponent,
    children: [
        {
            path: 'create-users',
            component: CreateUsersComponent
        },
        {
            path: 'manage-roles',
            component: ManageRolesComponent
        },
        {
            path: 'manage-users',
            component: UserManagerComponent
        },
        {
            path: 'manage-plan-type',
            component: ManagePlanTypeComponent
        },
        {
            path: 'manage-pub-type',
            component: ManagePubTypeComponent
        },
        {
            path: 'audit-trails',
            component: AuditTrailComponent
        },
        {
            path: 'impact-assessment-settings',
            component: ImpactAssessmentSettingsComponent
        },
        {
            path: 'rulebook-settings',
            component: RulebookSettingsComponent
        },
        {
            path: 'reporting-settings',
            component: ReportingSettingsComponent
        },
        {
            path: 'theme-settings',
            component: ThemeSettingsComponent
        },
        {
            path: 'project-name',
            component: ProjectNameListComponent
        }
    ]
}];
